import { TableV2 } from '@anytag/shared-atoms';
import { InstagramStoryPost } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerInstagramAnalyticsStoryDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerInstagramStoryPostsListTable } from './hooks';

interface InfluencerInstagramStoryPostsListProps extends TableData<InstagramStoryPost> {
  mainSocialAccountId?: number;
}

export const InfluencerInstagramStoryPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: InfluencerInstagramStoryPostsListProps) => {
  const { columns } = useInfluencerInstagramStoryPostsListTable();

  return (
    <>
      <TableV2 loading={loading} rowHeight="62px" columns={columns} data={data} noTopBorderRadius hasBorder />

      <InfluencerInstagramAnalyticsStoryDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
      />
    </>
  );
};
